import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppService } from 'src/@core/services/app.service';
import { JobService } from 'src/@core/services/job/job.service';
import { NotificationService } from 'src/@core/services/notification.service';
import { GET_QUOTATION } from 'src/@core/services/util/api.endpoints';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'hour4u-admin-compare-quotes',
  templateUrl: './compare-quotes.component.html',
  styleUrls: ['./compare-quotes.component.scss']
})
export class CompareQuotesComponent implements OnInit {

  displayColumns: any[] = [];
  displayRows: any = {};
  show: boolean = false;
  baseImageUrl = environment.image_url;
  data: any[] = [];
  resultsLength: number = 0;
  pageIndex: number = 0;
  pageSize: number = 20;
  pageSizeOptions: number[] = [10, 20, 50, 100, 500];
  isLoading: boolean = false;
  diameter = 30;
  color: string;
  mode = 'indeterminate';
  @ViewChild('tableRef', { static: true }) tableRef: ElementRef;
  profile = this.appService.getCurrentAccount();
  selectedJobData: any = null;

  constructor(
    private service: JobService,
    private notify: NotificationService,
    public dialogRef: MatDialogRef<CompareQuotesComponent>,
    @Inject(MAT_DIALOG_DATA) public selectedQuoteData: any,
    private http: HttpClient,
    private appService: AppService
  ) { }

  ngOnInit() {
    console.log(this.selectedQuoteData)
    // if (this.selectedQuoteData && this.selectedQuoteData._selected && this.selectedQuoteData._selected.length) {
    this.data = this.selectedQuoteData;
    if (this.selectedQuoteData && this.selectedQuoteData.length) {
      this.getJobById(this.selectedQuoteData[0].jobId)
    }
    // }
    // this.getQuotesData();
  }

  getJobById(id: any) {
    this.isLoading = true;
    console.log("#@@@@@@@@@", id)
    let params = {};
    if (this.profile && this.profile.entity && this.profile.entity.id) {
      if (this.profile.entity.entityType == 'AGENCY') {
        params = { 'entityId': this.profile.entity.id };
      }
    }
    if (id) {
      this.service.getJobDetailsById(id, params).subscribe((job: any) => {
        this.selectedJobData = job;
        this.isLoading = false;
        this.setColumns();
        this.setRows();
      })
    }
  }

  // get Quotes Data
  // getQuotesData() {
  //   this.isLoading = true;
  //   const sort = 'createdOn,desc';
  //   this.data = [];
  //   const httpParams = new HttpParams()
  //     .set('sort', sort)
  //     .set('page', this.pageIndex.toString())
  //     .set('size', this.pageSize.toString())

  //   this.http.get<any>(GET_QUOTATION, { params: httpParams }).subscribe(
  //     (response) => {
  //       this.isLoading = false;
  //       if (response && Array.isArray(response.content)) {
  //         this.data = response.content;
  //         this.setColumns();
  //         this.setRows();
  //       }
  //       this.resultsLength = response.totalElements;
  //     },
  //     (error) => {
  //       this.isLoading = false;
  //       console.error('Failed to fetch bookings:', error);
  //     }
  //   );
  // }

  // set Columns
  setColumns() {
    this.displayColumns = [];
    this.displayColumns.push({});
    this.data.forEach(ele => {
      console.log(ele)
      let obj = {
        code: ele.id,
        status: ele.status,
        approvedByUserDetails: ele.approvedByUserDetails,
        rejectedByUserDetails: ele.rejectedByUserDetails,
        sendByUserDetails: ele.sendByUserDetails
      }
      this.displayColumns.push(obj);
    })
  }

  // set Rows
  setRows() {
    this.displayRows['status'] = [];
    this.displayRows['finalAmount'] = [];
    this.displayRows['totalBilling'] = [];
    this.displayRows['gstAmount'] = [];
    this.displayRows['services'] = [];
    this.displayRows['variableJobRateCardsServices'] = [];
    this.displayRows['quoteValidity'] = [];
    this.displayRows['paymentTerms'] = [];
    this.displayRows['additionalTermsAndConditions'] = [];
    this.displayRows['attachments'] = [];
    this.displayRows['contactPerson'] = [];
    this.displayRows['phoneNo'] = [];
    this.displayRows['email'] = [];

    this.displayRows['status'].push("Status");
    this.displayRows['finalAmount'].push("Final Amount");
    this.displayRows['totalBilling'].push("Total billing");
    this.displayRows['gstAmount'].push("GST (18%)");
    this.displayRows['quoteValidity'].push("Quote validity");
    this.displayRows['paymentTerms'].push("Payment terms");
    this.displayRows['additionalTermsAndConditions'].push("Additional terms and conditions");
    this.displayRows['attachments'].push("Attachments");
    this.displayRows['contactPerson'].push("Contact person");
    this.displayRows['phoneNo'].push("Phone no.");
    this.displayRows['email'].push("Email");

    this.data.forEach((ele: any) => {
      ele.jobRateCards.forEach((element: any) => {
        this.displayRows[element.type] = [];
      })
    });

    this.data.forEach((ele: any) => {
      ele.variableJobRateCards.forEach((element: any) => {
        this.displayRows[element.type] = [];
      })
    });

    this.data.forEach((ele: any) => {
      ele.services = [];
      ele.variableJobRateCardsServices = [];
      ele.finalAmount = 0;
      ele.totalBilling = 0;
      ele.gstAmount = 0;
      if (this.selectedJobData && this.selectedJobData.billingType && this.selectedJobData.billingType.includes('FIXED')) {
        ele.jobRateCards.forEach((element: any, index) => {
          element.totalBilling = 0;
          element.totalBilling = (element.quantity * element.rate);
          // ele.finalAmount = ele.finalAmount + (element.quantity * (element.rate * 1.18));
          ele.totalBilling = ele.totalBilling + (element.quantity * element.rate * element.days);
          // ele.gstAmount = ele.gstAmount + ((element.quantity * element.rate * element.days) * 0.18);
          Object.keys(this.displayRows).forEach((el, i) => {
            if (el == element.type) {
              element.code = ele.code;
              ele.services[index] = element;
            }
          })
        });
      }

      if (this.selectedJobData && this.selectedJobData.billingType && this.selectedJobData.billingType.includes('VARIABLE')) {
        ele.variableJobRateCards.forEach((element: any, index) => {
          element.totalBilling = 0;
          element.totalBilling = (element.quantity * element.rate);
          // ele.finalAmount = ele.finalAmount + (element.quantity * (element.rate * 1.18));
          ele.totalBilling = ele.totalBilling + (element.quantity * element.rate);
          // ele.gstAmount = ele.gstAmount + ((element.quantity * element.rate) * 0.18);
          Object.keys(this.displayRows).forEach((el, i) => {
            if (el == element.type) {
              element.code = ele.code;
              ele.variableJobRateCardsServices[index] = element;
            }
          })
        });
      }
      console.log(ele)
      ele.gstAmount = ele.totalBilling * 0.18;
      ele.finalAmount = ele.totalBilling + ele.gstAmount;
      this.displayRows['status'].push(ele.status);
      this.displayRows['services'].push(ele.services);
      this.displayRows['variableJobRateCardsServices'].push(ele.variableJobRateCardsServices);
      this.displayRows['finalAmount'].push(ele.finalAmount);
      this.displayRows['totalBilling'].push(ele.totalBilling);
      this.displayRows['gstAmount'].push(ele.gstAmount);
      this.displayRows['quoteValidity'].push(ele.quoteConditions && ele.quoteConditions.quoteValidity ? ele.quoteConditions.quoteValidity : "-");
      this.displayRows['paymentTerms'].push(ele.quoteConditions && ele.quoteConditions.paymentTerms ? ele.quoteConditions.paymentTerms : "-");
      this.displayRows['additionalTermsAndConditions'].push(ele.quoteConditions && ele.quoteConditions.addtional ? ele.quoteConditions.addtional : "-");
      this.displayRows['attachments'].push(ele.attachment);
      if (ele.agencyDetails) {
        if (ele.agencyDetails.entityMeta) {
          this.displayRows['contactPerson'].push(ele.agencyDetails.entityMeta.name);
        }
        this.displayRows['phoneNo'].push(ele.agencyDetails.mobile);
        this.displayRows['email'].push(ele.agencyDetails.email);
      }

    });
    this.data.forEach((ele: any) => {
      ele.dtattata = [];
      Object.keys(this.displayRows).forEach((el, i) => {
        ele.jobRateCards.forEach((element: any, index) => {
          if (el == element.type) {
            element.code = ele.code;
            ele.dtattata[index] = element;
          }
        })
      })
    })
    let servicesArray = Object.assign([], this.displayRows['services']);
    let serviceData = this.groupByTypeAndFillEmpty(servicesArray);
    const groupedItems = this.groupByType(serviceData);
    this.displayRows['services'] = groupedItems;

    let variableJobRateCardsAarry = Object.assign([], this.displayRows['variableJobRateCardsServices']);
    let variableJobRateCardsData = this.groupByTypeAndFillEmpty(variableJobRateCardsAarry);
    const groupedVariableJobRateCardsItems = this.groupByType(variableJobRateCardsData);
    this.displayRows['variableJobRateCardsServices'] = groupedVariableJobRateCardsItems;

    setTimeout(() => {
      this.tableRef.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
      this.tableRef.nativeElement.scrollLeft = 0;
    }, 400);
  }

  // group by type 
  groupByType(data: any[]): any {
    let groupedData: any = {};
    data.forEach(item => {
      Object.keys(item).forEach(key => {
        if (!groupedData[key]) {
          groupedData[key] = [];
        }
        groupedData[key].push(item[key]);
      });
    });
    return groupedData;
  }

  // group by service type from basic array and if that particular type not found then set it to 0
  groupByTypeAndFillEmpty(data: any[]): any[] {
    let groupedData: any[] = [];

    data.forEach(row => {
      let groupedRow: any = {};

      row.forEach(item => {
        const type = item.type;

        if (!groupedRow.hasOwnProperty(type)) {
          groupedRow[type] = item;
        } else {
          groupedRow[type].quantity += item.quantity;
          groupedRow[type].rate += item.rate;
          groupedRow[type].totalAmount += item.totalAmount;
          groupedRow[type].totalBilling += item.totalBilling;
        }
      });

      // Fill in empty objects for any missing types
      let typesPresent = Object.keys(groupedRow);
      let allTypes = Array.from(new Set(data.flatMap(row => row.map(item => item.type))));

      allTypes.forEach(type => {
        if (!typesPresent.includes(type)) {
          groupedRow[type] = { type: type, quantity: "-", rate: "-", totalAmount: "-", totalBilling: "-" };
        }
      });

      // Sort the grouped row by type
      groupedRow = Object.fromEntries(Object.entries(groupedRow).sort());

      groupedData.push(groupedRow);
    });

    return groupedData;
  }

  // hide details view of breakdown 
  hider() {
    this.show = false;
  }

  // show details view of breakdown
  shower() {
    this.show = true;
  }

  // accept reject quote
  acceptRejectQuote(index, status) {
    this.data.forEach((ele, i) => {
      if (index == i + 1) {
        this.service.updateQuoteStatus(ele.id, status).subscribe(res => {
          this.dataRefreshIndividualRow(res);
          this.notify.showMessage('Quotation Status Updated Successfully!', 2000);
        }, ((err: any) => {
          this.notify.showMessage(err.error.message, 2000);
        }))
      }
    })
  }

  // refresh individual row
  dataRefreshIndividualRow(res) {
    this.data.forEach((ele: any, index) => {
      if (ele.id == res.id) {
        if (ele.jobRateCards && ele.jobRateCards.length) {
          ele.jobRateCards.forEach(ele => {
            ele.totalCost = ele.totalCost + ele.totalAmount;
            // ele.totalUnits = ele.totalUnits + ele.quantity;
          });
          ele.totalCost = ele.totalCost * 1.18;
        }
        ele.assignedEntitiesName = [];
        if (ele.assignedEntities && ele.assignedEntities.length) {
          ele.assignedEntities.forEach(ele => {
            ele.assignedEntitiesName.push(ele.name);
          });
        }
        this.data[index] = res;
        this.data = [...this.data];
        this.setColumns();
        this.setRows();
      }
    })
  }

  // close Pop-Up
  closePopUp() {
    this.dialogRef.close(true);
  }

  calcColumnWidth(): string {
    if (this.displayColumns.length < 5) {
      const columnWidth = 100 / this.displayColumns.length;
      return `calc(${columnWidth}% - 2px)`; // Adjusting for borders, margins, etc.
    } else {
      return
    }
  }
}
